import Vue from 'vue';
// import CoolMobileUI from '@igetcool/cool-mobile-ui/dist/noActivity/index.umd';
// import '@igetcool/cool-mobile-ui/dist/noActivity/index.css';
import CoolMToast from '@/components/Toast';
import CoolMLoading from '@/components/Loading';
import CoolMSkeleton from '@/components/Skeleton';
import CoolDoLogin from '@/components/H5Login/doLoginInstall';
import { vueExtends, httpRequest } from '@igetcool/base-components';
import axios from 'axios';
import qs from 'qs';

// Vue.use(CoolMobileUI);
Vue.use(CoolMToast);
Vue.use(CoolMLoading);
Vue.use(CoolMSkeleton);
Vue.use(CoolDoLogin);
Vue.use(vueExtends);


function _stringifyPostData(config) {
  const { headers = {}, method, data = {} } = config;
  if (method === 'post') {
    const contentType = (headers['Content-Type'] || '').toLowerCase();
    if (contentType.indexOf('application/json') === -1) {
      config.data = qs.stringify(data);
    }
  }
  return config;
}

axios.interceptors.request.use(config => {
  config = _stringifyPostData(config);
  return config;
});

httpRequest.config({
  init: (opts) => {
    const { axios: _axios } = opts;
    _axios.interceptors.request.use(config => {
      config = _stringifyPostData(config);
      return config;
    });
  }
});
